<template>
  <div>
    <!-- Mobile -->
    <div class="uk-hidden@m">
      <div class="uk-navbar-container">
        <nav uk-navbar class="uk-navbar">
          <div class="uk-navbar-left">
            <a class="uk-navbar-toggle" href="#sv-mobile" uk-toggle>
              <div uk-navbar-toggle-icon class="uk-icon uk-navbar-toggle-icon">
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  xmlns="http://www.w3.org/2000/svg"
                  data-svg="navbar-toggle-icon"
                >
                  <rect y="9" width="20" height="2" />
                  <rect y="3" width="20" height="2" />
                  <rect y="15" width="20" height="2" />
                </svg>
              </div>
            </a>
          </div>
          <div class="uk-navbar-center">
            <router-link to="/" class="uk-navbar-item uk-logo">
              <img
                src="../assets/studio8.svg"
                uk-svg
                height="50"
                alt="Studio8 Logo"
              />
            </router-link>
          </div>
        </nav>
      </div>
      <div id="sv-mobile" uk-offcanvas mode="push" overlay class="uk-offcanvas">
        <div class="uk-offcanvas-bar">
          <button
            class="uk-offcanvas-close uk-icon uk-close"
            type="button"
            uk-close
          >
            <svg
              width="14"
              height="14"
              viewBox="0 0 14 14"
              xmlns="http://www.w3.org/2000/svg"
              data-svg="close-icon"
            >
              <line
                fill="none"
                stroke="#000"
                stroke-width="1.1"
                x1="1"
                y1="1"
                x2="13"
                y2="13"
              />
              <line
                fill="none"
                stroke="#000"
                stroke-width="1.1"
                x1="13"
                y1="1"
                x2="1"
                y2="13"
              />
            </svg>
          </button>
          <div class="uk-child-width-1-1 uk-grid uk-grid-stack" uk-grid>
            <div>
              <div class="uk-panel">
                <ul class="uk-nav uk-nav-default">
                  <li class="uk-active">
                    <router-link to="/main">Hem</router-link>
                  </li>
                  <li>
                    <router-link to="/artists">Artister</router-link>
                  </li>
                  <li>
                    <router-link to="/about">Om oss</router-link>
                  </li>
                  <li>
                    <router-link to="/contact">Kontakta oss</router-link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Desktop -->
    <div class="uk-visible@m" uk-header>
      <div
        uk-sticky
        media="@m"
        sel-target=".uk-navbar-container"
        class="uk-sticky uk-sticky-fixed"
      >
        <div class="uk-navbar-container" uk-navbar>
          <div class="uk-container">
            <nav class="uk-navbar-center">
              <div class="uk-navbar-center-left">
                <ul class="uk-navbar-nav">
                  <li class="uk-active">
                    <router-link to="/main">Hem</router-link>
                  </li>
                  <li>
                    <router-link to="/artists">Artister</router-link>
                  </li>
                </ul>
              </div>
              <div class="uk-navbar-item uk-margin-medium-left uk-margin-medium-right menuLogo">
                <router-link to="/" class="uk-navbar-item uk-logo">
                  <img
                    src="../assets/studio8.svg"
                    uk-svg
                    height="150"
                    alt="Studio8 Logo"
                  />
                </router-link>
              </div>
              <div class="uk-navbar-center-right">
                <ul class="uk-navbar-nav">
                  <li>
                    <router-link to="/about">Om oss</router-link>
                  </li>
                  <li>
                    <router-link to="/contact">Kontakta oss</router-link>
                  </li>
                </ul>
              </div>
            </nav>
          </div>
        </div>
      </div>
      <div class="uk-sticky-placeholder"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Menu",
  data() {
    return {
      active: "Home"
    };
  },
  mounted() {
    // Fade Background Color on Navbar when scrolling from top
    const nav = document.querySelectorAll(".uk-navbar-container");

    var isMac = navigator.appVersion.indexOf("Mac") != -1;

    window.addEventListener("scroll", () => {
      nav.forEach(navbar => {
        if (isMac) {
          var opacityMe = (2050 - window.pageYOffset) / 2000;
          navbar.style.background = "rgba(18,18,18,0.8)".replace(
            /[^,]+(?=\))/,
            opacityMe
          );
          if (opacityMe <= 0.8) {
            navbar.style.background = "rgba(18,18,18,0.8)".replace(
              /[^,]+(?=\))/,
              "0.8"
            );
          }
        } else {
          navbar.style.background = "#121212";
        }
      });
    });
  },
  methods: {}
};
</script>
